import React from 'react'
import '../Cardpage.css'
import engmed1 from '../Images/EnglishMedicine1.jpg'
import engmed2 from '../Images/englishmed.jpg'
function EnglishMed() {
  return (
<>
    <div className='cardpagediv'>
      <h3 className='cardpagehead'>English Medicines</h3>
      <img src={engmed1} className='w-100 imgbanner'  alt="" />
    </div>
    <p className='cardpagepara1 ms-2 me-2'>
      We provide all high quality medicines to our customers with maximum discounts. 
      During this 22 years of our service we can assure that we have satisfied our all customers by giving them medicines they required.
      
    </p>
    <h5 className='cardpagehead5'>
          Major Medicine Brands we have:
        </h5>
    <div>
    <ul>
      <li>Mankind</li>
      <li>Sun Pharma</li>
      <li>Cipla</li>
      <li>Abbott</li>
      <li>Dr. Reddy's</li>
      <li>Micro Labs</li>
      <li>Anthus</li>
      <li>Cadilla</li>
      <li>Intas</li>
      <li>Knoll</li>
    </ul>
    </div>
    <p className='ms-2 pagebott'>We also have Home Delivery Facility based on purchase amount.</p>
    </>
  )
}

export default EnglishMed